import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accommodation-landing',
  templateUrl: './accommodation-landing.component.html',
  styleUrls: ['./accommodation-landing.component.css']
})
export class AccommodationLandingComponent implements OnInit {

  //Photo by <a href="https://unsplash.com/@abbiebernet?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Abbie Bernet</a> on <a href="https://unsplash.com/photos/beige-concrete-building-iVmUXothgGY?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
  //Photo by <a href="https://unsplash.com/@loganstrongarms?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Logan Armstrong</a> on <a href="https://unsplash.com/photos/aerial-view-of-city-buildings-during-daytime-hVhfqhDYciU?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
  //Photo by <a href="https://unsplash.com/@davidgildelacanal?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">David Gil de la Canal</a> on <a href="https://unsplash.com/photos/brown-and-white-concrete-buildings-under-blue-sky-during-daytime-O_TKfMbxCqI?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
  
  
  constructor() { }

  ngOnInit(): void {
  }

  goToCalendly(){
    window.open('https://calendly.com/voy-jaleas/30min?month=2023-02');
  }
  
  goToWebapp(){
    window.open('https://app.voyjaleas.com/#/sub-app/health-helper');
  }

}
